export default "__VITE_ASSET__CFHyFfrW__"